import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TableSortLabel } from "@mui/material";

interface Props {
  tableHeadings: { [key: string]: string };
  rows: any[];
}

const AllSubtractedValuesTable = ({ tableHeadings, rows }: Props) => {
  const headCells = Object.entries(tableHeadings);

  return (
    <>
      <Paper sx={{ boxShadow: "none" }}>
        <TableContainer className="">
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {headCells.map(([_, value], index) => (
                  <TableCell
                    key={index}
                    align="left"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    <TableSortLabel>
                      {value && typeof value === "string" ? value : ""}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, rowIndex) => (
                <React.Fragment key={row.field ?? rowIndex}>
                  <TableRow
                    sx={{
                      "& > *": {
                        borderBottom:
                          "1px solid rgba(224, 224, 224, 1) !important",
                      },
                    }}
                  >
                    {headCells.map(([key], cellIndex) => (
                      <TableCell key={cellIndex} align="left">
                        {key === "field" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : key === "subtracted_amount" ? (
                          <> {row[key] ? row[key] : "N/A"}</>
                        ) : (
                          "N/A"
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default AllSubtractedValuesTable;
